import { render, staticRenderFns } from "./DeviationColors.vue?vue&type=template&id=c5d53670"
import script from "./DeviationColors.vue?vue&type=script&lang=js"
export * from "./DeviationColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports